import ServiceElement from './ServiceElement'

export default ServiceElement
